import { useState } from 'react'
import { pb } from '../lib/pocketbase'

export default function PastDueBanner() {
  const [loading, setLoading] = useState(false)
  const [dismissed, setDismissed] = useState(false)

  if (dismissed) return null

  async function openBillingPortal() {
    setLoading(true)
    try {
      const res = await fetch('/api/billing?action=portal', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${pb.authStore.token}`,
        },
      })
      const data = await res.json()
      if (!res.ok) throw new Error(data.error || 'Failed to open billing portal')
      window.location.href = data.url
    } catch (err: any) {
      alert(err.message)
      setLoading(false)
    }
  }

  return (
    <div style={{
      background: '#A3453E',
      color: '#fff',
      padding: '10px 20px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '12px',
      fontSize: '14px',
      fontWeight: 500,
      zIndex: 1000,
      flexShrink: 0,
    }}>
      <span>
        Your payment is past due — AI features and some functionality may be restricted.{' '}
        <button
          onClick={openBillingPortal}
          disabled={loading}
          style={{
            background: 'none',
            border: '1px solid rgba(255,255,255,0.6)',
            borderRadius: 0,
            color: '#fff',
            cursor: 'pointer',
            padding: '2px 10px',
            fontSize: '13px',
            fontWeight: 600,
          }}
        >
          {loading ? 'Opening…' : 'Update Payment Method →'}
        </button>
      </span>
      <button
        onClick={() => setDismissed(true)}
        aria-label="Dismiss"
        style={{
          background: 'none',
          border: 'none',
          color: 'rgba(255,255,255,0.7)',
          cursor: 'pointer',
          fontSize: '18px',
          lineHeight: 1,
          padding: '0 4px',
        }}
      >
        ×
      </button>
    </div>
  )
}
